export const DEFAULT_DATA_IDENTITY_COMPANY = 'company_id';
